export const signInUpEnum = {
  SIGN_IN: "signIn",
  SIGN_UP: "signUp",
};

export const apiCodeEnum = {
  SUCCESS: 1,
  ERROR: 0,
};
